export const selectColorCode = (colors: string[]) => {
  const result = colors.find(c => null != c && c != "initial");
  return result || "initial";
}